import { Container } from 'react-bootstrap';

const SiteLaunchMessage = () => (
    <p className='mb-0 p-2 small text-black'>
        <span className='me-2 badge rounded-pill text-white bg-info'>
            <span className='visually-hidden'>NMI Services portal </span>
            Feedback
            <span className='visually-hidden'>:</span>
        </span>
        {'Fill in this '}
        <a
            // Site launch survey link
            href='https://industry.au1.qualtrics.com/jfe/form/SV_9X41DIbsi8FvCQu'
            rel='external'
            target='NMI-Feedback'
            className='small text-black'
        >
            quick survey
            <span className='visually-hidden'> Opens in a new tab</span>
        </a>
        <span className='d-none d-sm-inline'> to give your feedback</span>
        <span className='d-none d-lg-inline'> and help us to improve the NMI Services portal.</span>
    </p>
);

const SiteMaintenanceMessage = () => (
    <p className='mb-0 p-2 small text-black'>
        <span className='me-2 badge rounded-pill text-white bg-dark-red'>Site Maintenance</span>
        {' This site will be under maintenance from dd MMM YYYY until dd MMM YYYY.'}
    </p>
);

const NavbarMessage = () => (
    <Container fluid className='-bg-dark-gray -bg-light-blue bg-light-blue-tint'>
        <Container>
            <SiteLaunchMessage />
        </Container>
    </Container>
);

export default NavbarMessage;
